<template>
    <div class="a-details-main">
        <template v-if="name==='hfcz'">
            <hfcz @routePusht="goToRoute"></hfcz>
        </template>
        <template v-else-if="name==='sblj'">
            <sblj @routePusht="goToRoute"></sblj>
        </template>
        <template v-else-if="name==='tjyl'">
            <tjyl @routePusht="goToRoute"></tjyl>
        </template>
        <template v-else-if="name==='wsd'">
            <wsd @routePusht="goToRoute"></wsd>
        </template>
        <template v-else-if="name==='xc'">
            <xc @routePusht="goToRoute"></xc>
        </template>
        <template v-else-if="name==='zdfq'">
            <zdfq @routePusht="goToRoute"></zdfq>
        </template>
        <template v-else-if="name==='wbzx'">
            <wbzx @routePusht="goToRoute"></wbzx>
        </template>
        <template v-else-if="name==='xscs'">
            <xscs @routePusht="goToRoute"></xscs>
        </template>
        <template v-else-if="name==='sszk'">
            <sszk @routePusht="goToRoute"></sszk>
        </template>
        <template v-else-if="name==='jlfzm'">
            <jlfzm @routePusht="goToRoute"></jlfzm>
        </template>
          <template v-else-if="name==='snxd'">
            <snxd @routePusht="goToRoute"></snxd>
        </template>
           <template v-else-if="name==='jfsc'">
            <jfsc @routePusht="goToRoute"></jfsc>
        </template>
        <template v-else-if="name==='mrcj'">
            <mrcj @routePusht="goToRoute"></mrcj>
        </template>
         <template v-else-if="name==='nfbz'">
            <nfbz @routePusht="goToRoute"></nfbz>
        </template>
          <template v-else-if="name==='cdyx'">
            <cxyd @routePusht="goToRoute"></cxyd>
        </template>
          <template v-else-if="name==='hfdl'">
            <hfdl @routePusht="goToRoute"></hfdl>
        </template>
        <template v-else-if="name==='jxk'">
            <jxk @routePusht="goToRoute"></jxk>
        </template>
        <template v-else-if="name==='bjxk'">
            <bjxk @routePusht="goToRoute"></bjxk>
        </template>
        
    </div>
</template>

<script>
import hfcz from "./hfcz";
import sblj from "./sblj";
import tjyl from "./tjyl";
import wsd from "./wsd2";
import xc from "./xc";
import zdfq from "./zdfq";
import wbzx from "./wbzx2";
import xscs from "./xscs";
import sszk from "./sszk";
import jlfzm from "./jlfzm";
import snxd from "./snxd";
import jfsc from './jfsc';
import mrcj from './mrcj';
import nfbz from './nfbz';
import cxyd from './cxyd';
import hfdl from './hfdl';
import jxk from './jxk';
import bjxk from './bjxk';
export default {
    props: {
        name: {
            type: String,
            default() {
                return "";
            }
        }
    },
    components: {
        hfcz,
        sblj,
        tjyl,
        wsd,
        xc,
        zdfq,
        wbzx,
        xscs,
        sszk,
        jlfzm,
        snxd,
        jfsc,
        mrcj,
        nfbz,
        cxyd,
        hfdl,
        jxk,
        bjxk
    },
    methods: {
        goToRoute(path) {
            let isInside = path.indexOf("http") != -1;
            if (isInside) {
                window.location.href = path;
            } else {
                if (typeof path === "string") {
                    this.$router.push(path);
                } else {
                    this.$router.push({
                        name: path.path,
                        params: { name: path.name }
                    });
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
</style>